import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Paper,
  alpha
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

const GlyphSelector = ({ 
  selectedGlyph, 
  onGlyphChange, 
  availableGlyphs 
}) => {
  const theme = useTheme();

  return (
    <Paper 
      variant="outlined" 
      sx={{ 
        p: 2, 
        mb: 3, 
        bgcolor: alpha(theme.palette.background.paper, 0.6),
        borderColor: alpha(theme.palette.common.white, 0.1)
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth size="small">
            <InputLabel>Select a Glyph</InputLabel>
            <Select
              value={selectedGlyph}
              onChange={onGlyphChange}
              label="Select a Glyph"
            >
              {availableGlyphs.map((glyph) => (
                <MenuItem key={glyph} value={glyph}>
                  {glyph}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default GlyphSelector;